import { render, staticRenderFns } from "./DoncasterCity.vue?vue&type=template&id=f6ae9da8&scoped=true&"
import script from "./DoncasterCity.vue?vue&type=script&lang=js&"
export * from "./DoncasterCity.vue?vue&type=script&lang=js&"
import style0 from "./DoncasterCity.vue?vue&type=style&index=0&id=f6ae9da8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ae9da8",
  null
  
)

export default component.exports